import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3)
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500
  },
  image: {
    width: 128,
    height: 128
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%'
  }
}));
/**
 * Affiche toutes informations concernant
 * chaque produit d'une commande
 * @param {Object} item représente un seul produit présent dans la commande
 */
const ProductCard = ({ item }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item>
            {item.pictures[0] ? (
              <div className={classes.image}>
                <img
                  className={classes.img}
                  alt="complex"
                  src={item.pictures[0]}
                />
              </div>
            ) : (
              ''
            )}
          </Grid>
          <Grid item xs={12} container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  Référence produit :{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {item.externalReference}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {item.color && `Couleur : ${item.color}`}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {item.size && `Taille : ${item.size}`}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {item.description && (
                    <span>
                      Description : <br /> {item.description}
                    </span>
                  )}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.ean13 && `Code-barres: ${item.ean13}`}
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {item.batchReference && (
                    <span>
                      Lot demandé : <br /> {item.batchReference}
                    </span>
                  )}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.batches && item.batches.length && (
                    <span>
                      Lot expédié : <br />{' '}
                    </span>
                  )}
                  {item.batches.length
                    ? item.batches.map(element => (
                        <span>
                          {' '}
                          {`${element.reference} : ${element.quantity}`}{' '}
                        </span>
                      ))
                    : null}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.details.length > 0 && (
                    <>
                      <span>Imei :</span>
                      {item.details.map(detail => (
                        <span> {detail.imei} </span>
                      ))}
                    </>
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1">
                {item.quantity ? `Quantité : ${item.quantity}` : null}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

ProductCard.propTypes = {
  item: PropTypes.object.isRequired
};

export default ProductCard;
